import type {Opportunity} from "./opportunityIntelligenceDemoData";
import {STAGE_LABEL} from "./opportunityUtils";

const HEADERS = ['ID', 'Opportunity', 'Detector', 'Summary', 'Source', 'Stage', 'Confidence', 'Owner', 'Identified value', 'Currency'];

function escapeCsv(value: string | number): string {
    const s = String(value);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function exportOpportunitiesCsv(rows: Opportunity[], fileName = 'opportunities'): void {
    const lines = [HEADERS.join(',')];
    for (const o of rows) {
        lines.push([
            o.sitId ?? o.id,
            o.title,
            o.detector,
            o.summary,
            o.source.label,
            STAGE_LABEL[o.stage],
            `${o.confidence}%`,
            o.owner,
            o.identifiedValue,
            o.currency,
        ].map(escapeCsv).join(','));
    }

    const blob = new Blob([lines.join('\n')], {type: 'text/csv;charset=utf-8;'});
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${fileName}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
